// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maquetes-simple-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #f1f5f9;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* O cabeçalho agora usa a classe global .top-bar definida em Layout.css */

.template-controls {
    display: flex;
    gap: 10px;
}

.template-controls select {
    padding: 8px 12px;
    border: 1px solid #cbd5e0;
    border-radius: 6px;
    font-size: 0.95em;
}

.template-controls button {
    padding: 8px 16px;
    background: #4299e1;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.95em;
    transition: background 0.2s;
}

.template-controls button:hover {
    background: #3182ce;
}

.template-controls .btn-save {
    background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
    font-weight: 600;
}

.template-controls .btn-save:hover {
    background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
    transform: translateY(-1px);
    box-shadow: 0 6px 15px rgba(72, 187, 120, 0.4);
}

.maquetes-simple-workspace {
    display: flex;
    flex: 1 1;
    overflow: hidden;
    background: #edf2f7;
}

.left-sidebar {
    width: 300px;
    background: #ffffff;
    border-right: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 15px;
    gap: 15px;
    box-shadow: 2px 0 15px rgba(0, 0, 0, 0.02);
}

.right-sidebar {
    width: 360px;
    background: #ffffff;
    border-left: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 15px;
    gap: 15px;
    box-shadow: -2px 0 15px rgba(0, 0, 0, 0.02);
}

.canvas-area-simple {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px;
    overflow: auto;
    background: #e2e8f0;
    background-image:
        radial-gradient(#cbd5e1 1px, transparent 1px);
    background-size: 20px 20px;
}


.maquetes-dashboard {
    flex: 1 1;
    overflow-y: auto;
    padding: 30px;
    background: #edf2f7;
}

.obras-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.obra-maquete-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border: 1px solid transparent;
}

.obra-maquete-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
    border-color: #4299e1;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-header .posicao {
    font-weight: bold;
    color: #4a5568;
    font-size: 1.1em;
}

.status-tag {
    font-size: 0.75em;
    padding: 4px 10px;
    border-radius: 20px;
    font-weight: 600;
    text-transform: uppercase;
}

.status-tag.has-maquete {
    background: #c6f6d5;
    color: #22543d;
}

.status-tag.no-maquete {
    background: #fed7d7;
    color: #822727;
}

.card-body h4 {
    margin: 0 0 5px 0;
    color: #2d3748;
}

.card-body p {
    margin: 0;
    font-size: 0.9em;
    color: #718096;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;

    overflow: hidden;
}

.card-footer {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #edf2f7;
    padding-top: 15px;
}

.card-footer small {
    color: #a0aec0;
}

.btn-edit-maquete {
    padding: 6px 12px;
    background: #ebf8ff;
    color: #3182ce;
    border: 1px solid #bee3f8;
    border-radius: 6px;
    font-size: 0.85em;
    font-weight: 600;
}

/* .btn-back e .top-bar agora são globais */

.btn-add-page {
    width: 100%;
    padding: 10px;
    background: white;
    color: #4a5568;
    border: 2px dashed #cbd5e0;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 15px;
}

.btn-add-page:hover {
    border-color: #4299e1;
    color: #4299e1;
    background: #ebf8ff;
}`, "",{"version":3,"sources":["webpack://./src/pages/MaquetesSimple.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uFAAuF;AAC3F;;AAEA,0EAA0E;;AAE1E;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,2CAA2C;AAC/C;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB;qDACiD;IACjD,0BAA0B;AAC9B;;;AAGA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;;IAE5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,2CAA2C;;AAE3C;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB","sourcesContent":[".maquetes-simple-page {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100vh;\r\n    background: #f1f5f9;\r\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\r\n}\r\n\r\n/* O cabeçalho agora usa a classe global .top-bar definida em Layout.css */\r\n\r\n.template-controls {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.template-controls select {\r\n    padding: 8px 12px;\r\n    border: 1px solid #cbd5e0;\r\n    border-radius: 6px;\r\n    font-size: 0.95em;\r\n}\r\n\r\n.template-controls button {\r\n    padding: 8px 16px;\r\n    background: #4299e1;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 0.95em;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.template-controls button:hover {\r\n    background: #3182ce;\r\n}\r\n\r\n.template-controls .btn-save {\r\n    background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);\r\n    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);\r\n    font-weight: 600;\r\n}\r\n\r\n.template-controls .btn-save:hover {\r\n    background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 6px 15px rgba(72, 187, 120, 0.4);\r\n}\r\n\r\n.maquetes-simple-workspace {\r\n    display: flex;\r\n    flex: 1;\r\n    overflow: hidden;\r\n    background: #edf2f7;\r\n}\r\n\r\n.left-sidebar {\r\n    width: 300px;\r\n    background: #ffffff;\r\n    border-right: 1px solid #e2e8f0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n    padding: 15px;\r\n    gap: 15px;\r\n    box-shadow: 2px 0 15px rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.right-sidebar {\r\n    width: 360px;\r\n    background: #ffffff;\r\n    border-left: 1px solid #e2e8f0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n    padding: 15px;\r\n    gap: 15px;\r\n    box-shadow: -2px 0 15px rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.canvas-area-simple {\r\n    flex: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 60px;\r\n    overflow: auto;\r\n    background: #e2e8f0;\r\n    background-image:\r\n        radial-gradient(#cbd5e1 1px, transparent 1px);\r\n    background-size: 20px 20px;\r\n}\r\n\r\n\r\n.maquetes-dashboard {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 30px;\r\n    background: #edf2f7;\r\n}\r\n\r\n.obras-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 20px;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.obra-maquete-card {\r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n.obra-maquete-card:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\r\n    border-color: #4299e1;\r\n}\r\n\r\n.card-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.card-header .posicao {\r\n    font-weight: bold;\r\n    color: #4a5568;\r\n    font-size: 1.1em;\r\n}\r\n\r\n.status-tag {\r\n    font-size: 0.75em;\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.status-tag.has-maquete {\r\n    background: #c6f6d5;\r\n    color: #22543d;\r\n}\r\n\r\n.status-tag.no-maquete {\r\n    background: #fed7d7;\r\n    color: #822727;\r\n}\r\n\r\n.card-body h4 {\r\n    margin: 0 0 5px 0;\r\n    color: #2d3748;\r\n}\r\n\r\n.card-body p {\r\n    margin: 0;\r\n    font-size: 0.9em;\r\n    color: #718096;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n\r\n    overflow: hidden;\r\n}\r\n\r\n.card-footer {\r\n    margin-top: auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-top: 1px solid #edf2f7;\r\n    padding-top: 15px;\r\n}\r\n\r\n.card-footer small {\r\n    color: #a0aec0;\r\n}\r\n\r\n.btn-edit-maquete {\r\n    padding: 6px 12px;\r\n    background: #ebf8ff;\r\n    color: #3182ce;\r\n    border: 1px solid #bee3f8;\r\n    border-radius: 6px;\r\n    font-size: 0.85em;\r\n    font-weight: 600;\r\n}\r\n\r\n/* .btn-back e .top-bar agora são globais */\r\n\r\n.btn-add-page {\r\n    width: 100%;\r\n    padding: 10px;\r\n    background: white;\r\n    color: #4a5568;\r\n    border: 2px dashed #cbd5e0;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    transition: all 0.2s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.btn-add-page:hover {\r\n    border-color: #4299e1;\r\n    color: #4299e1;\r\n    background: #ebf8ff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
